import { render } from "./SessionComplete.vue?vue&type=template&id=c80598fc&ts=true"
import script from "./SessionComplete.vue?vue&type=script&lang=ts"
export * from "./SessionComplete.vue?vue&type=script&lang=ts"

import "./SessionComplete.vue?vue&type=style&index=0&id=c80598fc&lang=scss"

import exportComponent from "/home/node/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__